import { BorderColor } from "@mui/icons-material";

export function TextField(theme) {
	return {
		MuiInputBase: {
			styleOverrides: {
				root: {
					borderRadius: '8px !important',
					fontSize: '12px',
					fontWeight: 500,
					'&:hover .MuiOutlinedInput-notchedOutline':{
						borderColor:'#fff !important',
						fontWeight: '500',
					},
					'& .MuiOutlinedInput-input': {
						fontSize: '12px',
						fontWeight: '500',
					}
				},
				input: {
					fontSize: '12px',
					fontWeight: '500',
				}
			}
		}
	}
}